import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { notifications } from "@mantine/notifications";
import {
  accountReportDeliveryService,
  CreateAccountReportDeliveryInput,
  UpdateAccountReportDeliveryInput,
} from "../../services/admin/accountreportdelivery.service";

export function useAccountReportDeliveryAdmin() {
  return useQuery({
    queryKey: ["accountReportDelivery", "admin"],
    queryFn: () => accountReportDeliveryService.getAll(),
  });
}

export function useCreateAccountReportDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: CreateAccountReportDeliveryInput) =>
      accountReportDeliveryService.create(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accountReportDelivery"] });
      notifications.show({
        title: "Success",
        message: "Account report delivery created successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to create account report delivery",
        color: "red",
      });
    },
  });
}

export function useUpdateAccountReportDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: UpdateAccountReportDeliveryInput) =>
      accountReportDeliveryService.update(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accountReportDelivery"] });
      notifications.show({
        title: "Success",
        message: "Account report delivery updated successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to update account report delivery",
        color: "red",
      });
    },
  });
}

export function useToggleAccountReportDeliveryActive() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) =>
      accountReportDeliveryService.toggleActive(id, isActive),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accountReportDelivery"] });
      notifications.show({
        title: "Success",
        message: "Account report delivery status updated successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message:
          error.message || "Failed to update account report delivery status",
        color: "red",
      });
    },
  });
}

export function useDeleteAccountReportDelivery() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => accountReportDeliveryService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["accountReportDelivery"] });
      notifications.show({
        title: "Success",
        message: "Account report delivery deleted successfully",
        color: "green",
      });
    },
    onError: (error: any) => {
      notifications.show({
        title: "Error",
        message: error.message || "Failed to delete account report delivery",
        color: "red",
      });
    },
  });
}
